// client/src/App.tsx
import { Provider } from 'react-redux';
import { store } from './store';
import AppContent from './AppContent'; // Import the new AppContent component

// Remove other imports that were moved to AppContent.tsx
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider } from './providers/AuthProvider';
// import { Toaster } from 'react-hot-toast';
// import MainLayout from './components/layout/MainLayout';
// ... and so on for all components and pages previously imported here
// import { RootState } from './store';
// import { useSelector } from 'react-redux';

function App() {
  // All the logic previously here (useSelector, isAdmin, hasAccess) is now in AppContent
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;